import { components, numberToPxOrString, proxy } from '@/utils'

import { basic, core } from '@/components/g/input/mixins'

import render from './render'

export default {
  name: components.textarea,

  mixins: [ core('textarea'), proxy(), basic('textarea') ],

  props: {
    resize: {
      type: String,
      default: 'none',
      validator: value => {
        return !!~[
          'none',
          'both',
          'horizontal',
          'vertical'
        ].indexOf(value)
      }
    },

    grow: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      inputHeight: undefined,
      userResized: false,
      _resizeObserver: undefined
    }
  },

  computed: {
    growDisabled() {
      return !this.grow || this.userResized
    },

    defaultHeight() {
      if (this.rows) {
        return this.rows * 18
      }

      return 0
    }
  },

  watch: {
    proxy() {
      if (!this.growDisabled) {
        this._delayedResize()
      }
    },

    resize() {
      if (this._data._resizeObserver) {
        this._data._resizeObserver.disconnect()
        this._data._resizeObserver = undefined
      }
      this._observeResize()
    }
  },

  mounted() {
    this._setRequired()
    this._autoFocus()

    this._setInitialHeight()
    this._observeResize()
    this._delayedResize()
  },

  beforeDestroy() {
    if (this._data._resizeObserver) {
      this._data._resizeObserver.disconnect()
    }
  },

  methods: {
    _setInitialHeight() {
      if (this.input) {
        if (this.defaultHeight) {
          this.inputHeight = this.defaultHeight
        } else {
          this.inputHeight = this.input.scrollHeight
        }

        this.input.style.height = numberToPxOrString(this.inputHeight)
      }
    },

    _observeResize() {
      if (this.resize === 'none') {
        return
      }

      if (this.input) {
        this._data._resizeObserver = new ResizeObserver(() => {
          if (this.input.offsetHeight !== this.inputHeight) {
            this.userResized = true
            this.inputHeight = this.input.offsetHeight
          }
        })

        this._data._resizeObserver.observe(this.input)
      }
    },

    _resizeHeight() {
      if (this.growDisabled) {
        return
      }

      if (this.input) {
        this._data._resizeObserver?.disconnect()

        this.input.style.height = 'auto'
        this.inputHeight = Math.max(this.input.scrollHeight, this.defaultHeight)
        this.input.style.height = numberToPxOrString(this.inputHeight)

        this._data._resizeObserver?.observe(this.input)
      }
    },

    _delayedResize() {
      this.$nextTick(this._resizeHeight)
    }
  },

  render
}
